<template>


<ICountUp
        :delay="delay"
        :endVal="endVal"
        :options="options"
        @ready="onReady"
      />

</template>

<script>

import ICountUp from 'vue-countup-v2'
export default {
    components: {
    ICountUp
  },
  props:{
    endVal:{
      type:Number,
      default:999
    },

  },
  data () {
    return {
      delay: 500,
      // endVal: 2532,
      options:{
        startVal: 0,
        duration: 2,
        useEasing: true,
        useGrouping: true,
        enableScrollSpy:true,  //到可视区域时动画
        scrollSpyOnce:true,  //只动画一次
        scrollSpyDelay:0, //到区域后多久开始
        separator: ',',
        decimal: '.',
        suffix: '+'
    }
    }
  },
   mounted() {
  },
  methods: {
    onReady: function (instance, CountUp) {
      const that = this
      instance.update(that.endVal)
    },

  }
}
</script>

<style>
</style>
